import MarketingShell from '../../components/marketing-shell/MarketingShell'
import MarketingIcon from '../../components/marketing-icon/MarketingIcon'
import MarketingCtaStrip from '../../components/marketing-cta-strip/MarketingCtaStrip'
import { MARKETING_FEATURE_CATEGORIES } from '../../_data/marketingContent'
import {
  CategoriesInner,
  CategoriesSection,
  CategoryBody,
  CategoryBullet,
  CategoryBullets,
  CategoryCard,
  CategoryHead,
  CategoryTitle,
  Hero,
  HeroEyebrow,
  HeroHeadline,
  HeroInner,
  HeroSubhead,
} from './styled'

const FeaturesPage = (): JSX.Element => (
  <MarketingShell>
    <Hero>
      <HeroInner>
        <HeroEyebrow>Features</HeroEyebrow>
        <HeroHeadline>Features that earn their keep.</HeroHeadline>
        <HeroSubhead>
          Every feature you&apos;d expect from a real scheduling tool, and
          nothing built just to pad out a comparison chart. Six categories,
          honest copy.
        </HeroSubhead>
      </HeroInner>
    </Hero>

    <CategoriesSection>
      <CategoriesInner>
        {MARKETING_FEATURE_CATEGORIES.map((category) => (
          <CategoryCard key={category.key}>
            <CategoryHead>
              <MarketingIcon kind={category.iconKind} size="large" />
              <CategoryTitle>{category.title}</CategoryTitle>
              <CategoryBody>{category.body}</CategoryBody>
            </CategoryHead>
            <CategoryBullets>
              {category.bullets.map((bullet) => (
                <CategoryBullet key={bullet}>{bullet}</CategoryBullet>
              ))}
            </CategoryBullets>
          </CategoryCard>
        ))}
      </CategoriesInner>
    </CategoriesSection>

    <MarketingCtaStrip
      eyebrow="Ready to try it"
      headline="Less feature shopping. More booked meetings."
      body="QuickCal ships with every category above wired up. Spin up an account and the booking flow is live the same day."
      secondaryLabel="See use cases"
      secondaryHref="/use-cases"
    />
  </MarketingShell>
)

export default FeaturesPage
